import _ from 'lodash';
export * from './offersHelpers';
export * from './filterSelectors';
export * from './sortSelectors';

export const SET_DATA = 'mp/offers/SET_DATA';
export const SET_OFFERS = 'mp/offers/SET_OFFERS';
export const UPDATE_FILTER = 'mp/offers/UPDATE_FILTER';
export const UPDATE_SUBFILTER = 'mp/offers/UPDATE_SUBFILTER';
export const CLEAR_SUBFILTERS = 'mp/offers/CLEAR_SUBFILTERS';
export const UPDATE_PRICE = 'mp/offers/UPDATE_PRICE';
export const UPDATE_SORT = 'mp/offers/UPDATE_SORT';
export const ADD_OFFER = 'mp/offers/ADD_OFFER';
export const TOGGLE_MOBILEFILTERS = 'mp/offers/TOGGLE_MOBILEFILTERS';
export const HIDE_MOBILEFILTERS = 'mp/offers/HIDE_MOBILEFILTERS';

export const initialState = {
  loaded: false,
  offerData: [],
  localized: true,
  mobileFilters: {
    open: false,
    hidden: false
  },
  filterData: [{
    lob: {
      name: "LinesOfBusiness",
      label: "TV",
      id: "lob-tv",
      value: "TV",
      selected: false,
      order: 1
    }
  }, {
    lob: {
      name: "LinesOfBusiness",
      label: "Internet",
      id: "lob-internet",
      value: "Internet",
      selected: false,
      order: 2
    }
  }, {
    lob: {
      name: "LinesOfBusiness",
      label: "Phone",
      id: "lob-voice",
      value: "Voice",
      selected: false,
      order: 3
    }
  }, {
    lob: {
      name: "LinesOfBusiness",
      label: "Home Security",
      id: "lob-home",
      value: "Home",
      selected: false,
      order: 4
    }
  }, {
    name: "Monthly Price Range",
    legend: "Monthly Price Range",
    isSlider: true,
    options: [{
      name: "Price",
      min: 0,
      max: 0,
      step: 1,
      value: 0,
      lowerValue: 0,
      message: "Pricing does not include equipment, installation, taxes and fees, and other applicable charges.",
      id: "Price",
      label: "Monthly Price Range"
    }]
  }],
  sortItems: [{
    id: null,
    label: "Price",
    options: [{
      key: "priceValue",
      type: "numeric",
      dir: "asc",
      name: "Price: Low to High"
    }, {
      key: "priceValue",
      type: "numeric",
      dir: "desc",
      name: "Price: High to Low"
    }],
    LOB: null
  }, {
    id: "sort-tv",
    label: "TV",
    options: [{
      key: "tvPackage.numberOfChannels",
      type: "numeric",
      dir: "desc",
      name: "Most Channels"
    }],
    LOB: "lob-tv"
  }, {
    id: "sort-hsd",
    label: "Internet",
    options: [{
      key: "internetPackage.internetDownloadSpeedMbps",
      type: "numeric",
      dir: "desc",
      name: "Fastest Speeds"
    }],
    LOB: "lob-internet"
  }],
  currentSort: ['priceValue', 'asc'],
  sortTitle: "Sort Your Options",
  channelLineupLogos: {
    All: ["cinemax", "hbo", "showtime", "starz"],
    "Limited Basic": [],
    "Digital Economy": [],
    "Digital Preferred": ["cinemax", "starz", "hbo", "showtime"],
    "Digital Premier": ["cinemax", "hbo", "showtime", "starz"],
    "Digital Premium": [],
    "Digital Starter": [],
    "Xfinity Tv 200 Latino": [],
    "Xfinity Tv 300 Latino": [],
    "Xfinity Tv 450 Latino": []
  },
  offerCardGigabitLearnMoreUrl: '',
  enableDefaultLobs: false,
  showOffersForLobs: {}
};

export const offers = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_DATA: {

      const filterDataLobs = action.payload.enableDefaultLobs ? action.payload.filterData : [...state.filterData.slice(0, 4), ...action.payload.filterData];

      return {
        ...state,
        ...action.payload,
        filterData: [
          ...filterDataLobs
        ]
      };
    }

    case SET_OFFERS: {
      return {
        ...state,
        loaded: true,
        offerData: action.offers.offers,
        offerCount: action.offers.offerCount,
        offerMinimumPrice: action.offers.offerMinimumPrice,
        offerCardGigabitLearnMoreUrl: action.offers.offerCardGigabitLearnMoreUrl,
        filterData: action.offers.filters,
        enableDynamicLobSelection: action.offers.enableDynamicLobSelection
      };
    }
    case UPDATE_FILTER:
      return {
        ...state,
        filterData: [
          ...state.filterData.slice(0, action.index),
          {
            ...state.filterData[action.index],
            lob: {
              ...state.filterData[action.index].lob,
              selected: action.selected
            }
          },
          ...state.filterData.slice(action.index + 1)
        ]
      };
    case UPDATE_SUBFILTER: {
      const filterIndex = _.findIndex(state.filterData, ['options[0].name', action.filterName]);
      const optionIndex = _.findIndex(state.filterData[filterIndex].options[0].options, ['id', action.optionId]);

      return {
        ...state,
        filterData: [
          ...state.filterData.slice(0, filterIndex),
          {
            ...state.filterData[filterIndex],
            options: [{
              ...state.filterData[filterIndex].options[0],
              options: [
                ...state.filterData[filterIndex].options[0].options.slice(0, optionIndex),
                {
                  ...state.filterData[filterIndex].options[0].options[optionIndex],
                  selected: action.selected
                },
                ...state.filterData[filterIndex].options[0].options.slice(optionIndex + 1)
              ]
            }]
          },
          ...state.filterData.slice(filterIndex + 1)
        ]
      };
    }
    case CLEAR_SUBFILTERS: {
      return {
        ...state,
        filterData: state.filterData.map((filter) => {
          return {
            ...filter,
            options: filter.options && filter.options.map((option) => {
              return {
                ...option,
                options: option.options && option.options.map((subOption) => {
                  return {
                    ...subOption,
                    selected: false
                  };
                })
              };
            })
          };
        })
      };
    }
    case UPDATE_PRICE: {
      const filterIndex = _.findIndex(state.filterData, ['options[0].name', action.filterName]);

      return {
        ...state,
        filterData: [
          ...state.filterData.slice(0, filterIndex),
          {
            ...state.filterData[filterIndex],
            options: [{
              ...state.filterData[filterIndex].options[0],
              value: action.value,
              lowerValue: action.lowerValue
            }]
          },
          ...state.filterData.slice(filterIndex + 1)
        ]
      };
    }
    case UPDATE_SORT: {
      return {
        ...state,
        currentSort: action.selected
      };
    }
    case TOGGLE_MOBILEFILTERS: {
      return {
        ...state,
        mobileFilters: {
          ...state.mobileFilters,
          open: !state.mobileFilters.open
        }
      };
    }
    case HIDE_MOBILEFILTERS: {
      return {
        ...state,
        mobileFilters: {
          ...state.mobileFilters,
          hidden: !state.mobileFilters.hidden
        }
      };
    }
    default:
      return state;
  }
};

export const setOffers = offers => {
  return {
    type: SET_OFFERS,
    offers
  };
};

export const addOfferToCart = (offer, force, currentLOBs) => {
  return {
    type: ADD_OFFER,
    force: force,
    overlayName: offer.overlayName,
    currentLOBs: currentLOBs,
    offer: {
      offerId: offer.id || offer.offerId,
      offerLOBs: _.join(offer.linesOfBusiness, '|') || offer.offerLOBs
    }
  };
};

export const updateFilter = (selected, index) => {
  return {
    type: UPDATE_FILTER,
    selected,
    index
  };
};

export const updateSubFilter = (selected, filterName, optionId) => {
  return {
    type: UPDATE_SUBFILTER,
    selected,
    filterName,
    optionId
  };
};

export const clearSubFilters = () => {
  return {
    type: CLEAR_SUBFILTERS
  };
};

export const updatePrice = (filterName, value, lowerValue) => {
  return {
    type: UPDATE_PRICE,
    filterName,
    value,
    lowerValue
  };
};

export const updateSort = (selected) => {
  return {
    type: UPDATE_SORT,
    selected
  };
};

export const toggleMobileFilters = () => {
  return {
    type: TOGGLE_MOBILEFILTERS
  };
};

export const hideMobileFilters = () => {
  return {
    type: HIDE_MOBILEFILTERS
  };
};

export default offers;



/** WEBPACK FOOTER **
 ** ./client/redux/modules/data/offers/offers.js
 **/